export const DOCUMENT_BEGIN_WRITE_DATA = 'DOCUMENT/BEGIN_WRITE_DATA';
export const DOCUMENT_COMPLETE_WRITE_DATA = 'DOCUMENT/COMPLETE_WRITE_DATA';
export const DOCUMENT_REQUEST_DATA = 'DOCUMENT/REQUEST_DATA';
export const RECEIVE_DOCUMENTS = 'DOCUMENT/RECEIVE_DOCUMENTS';
export const INITIATE_UPLOAD = 'DOCUMENT/INITIATE_UPLOAD';
export const UPLOAD_SUCCESS = 'DOCUMENT/UPLOAD_SUCCESS';
export const UPLOAD_ERROR = 'DOCUMENT/UPLOAD_ERROR';
export const REMOVE_DOCUMENT_FROM_QUEUE = 'DOCUMENT/REMOVE_DOCUMENT_FROM_QUEUE';
export const DELETE_DOCUMENT = 'DOCUMENT/DELETE_DOCUMENT';
